export const PlayerMigratedCookie = {
    key: 'player_migrated',
    expirationDays: 360,
};

export enum MrGreenMigrationElasticEvents {
    MIGRATION_EVENT = 'MIGRATION_EVENT',
}

export enum MRGreenMigrationSourceEvent {
    VISITOR = 'Visitor',
    MRG_REDIRECTION = 'MRG_Redirect',
}

export enum MRGreenMigrationEventAction {
    ENTER = 'Enter',
}

export enum MRGreenMigrationEventCategory {
    VISITOR = 'Visitor',
}
